var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow_upward_alt"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1986_44824",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1986_44824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_upward_alt_2",
    d: "M7.33333 12.0026V5.86927L4.93333 8.26927L4 7.33594L8 3.33594L12 7.33594L11.0667 8.26927L8.66667 5.86927V12.0026H7.33333Z",
    fill: "#0D8066"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpTooltip);
export default __webpack_public_path__ + "static/media/ArrowUpTooltip.bee16f250648addac2e7f2433b5ab63f.svg";
export { ForwardRef as ReactComponent };